import { render, staticRenderFns } from "./AddProductModal.vue?vue&type=template&id=87325ffe&scoped=true&"
import script from "./AddProductModal.vue?vue&type=script&lang=js&"
export * from "./AddProductModal.vue?vue&type=script&lang=js&"
import style0 from "./AddProductModal.vue?vue&type=style&index=0&id=87325ffe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87325ffe",
  null
  
)

export default component.exports